import React, { useEffect, useState } from 'react';
import { countdownSeconds } from '../data/offer';
export function Countdown() {
  const [left, setLeft] = useState(countdownSeconds);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setLeft(s => s <= 1 ? countdownSeconds : s - 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const parts = [{
    label: 'Hours',
    value: Math.floor(left / 3600)
  }, {
    label: 'Minutes',
    value: Math.floor(left % 3600 / 60)
  }, {
    label: 'Seconds',
    value: left % 60
  }];
  return <div className="mt-8 w-full text-center" role="timer" aria-live="off" data-id="element-2" data-mp="3gyw69tzj8pjw">
      <p className="font-display text-lg font-bold uppercase tracking-[0.1em] text-flame" data-id="element-3" data-mp="3259haztx35te">The promotional price ends in:</p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-4" data-mp="374vvpclhes3s">
        {parts.map((p, i) => <React.Fragment key={p.label} data-id="element-5" data-mp="15bg1y6u3kx4l" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-6" data-mp="15adb1ywryuoo">
              <span className="flex h-16 w-[4.5rem] items-center justify-center rounded-xl bg-navy-950 font-display text-4xl font-extrabold tabular-nums text-white ring-1 ring-white/10 sm:h-20 sm:w-24 sm:text-5xl" data-id="element-7" data-mp="y16mhehpwdst">
                {String(p.value).padStart(2, '0')}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-400" data-id="element-8" data-mp="17sst0xj41op8">{p.label}</span>
            </div>
            {i < parts.length - 1 && <span className="pt-3 font-display text-4xl font-extrabold text-flame sm:pt-4 sm:text-5xl" aria-hidden="true" data-id="element-9" data-mp="f2kjtv6jyems">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}